import { render, staticRenderFns } from "./Cobranca.vue?vue&type=template&id=2208f3d2&scoped=true"
import script from "./Cobranca.vue?vue&type=script&lang=js"
export * from "./Cobranca.vue?vue&type=script&lang=js"
import style0 from "./Cobranca.vue?vue&type=style&index=0&id=2208f3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208f3d2",
  null
  
)

export default component.exports